





















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import doughnutChart from '../charts/doughnutReactive.vue';

@Component({
  components: {
    doughnutChart,
  }
})
export default class userFillersChart extends Vue {
  @Prop() private data!: any;
  private total: number = 0;
  private labels: string[]  = [];
  private fillerdata: number[] = [];
  private datacollection: any = null;
  private options: any = {
    showScale: true,
    tooltips: {
      enabled: false
    }
  }
  private colors: string[]  = [
    '#00b4e3',
    '#f74657',
    '#38d17a',
    '#ffcc00',
    '#008CB1',
    '#DD2234',
    '#19AD59',
    '#F7B700',
    '#8BDFF5',
    '#FF8D8D',
    '#8FEE9E',
    '#FFEB99',
    '#EAFBFF',
    '#FFBEBE',
    '#D7FFDE',
    '#FFF3C5'
  ]

  private created() {
    this.onDataChanged();
  }

  private percentFromTotal(part: number, total: number) {
    return Math.round(part / total * 100);
  }

  @Watch('data')
  private onDataChanged() {
    if (Object.keys(this.data).length) {
      this.fillerdata = [];
      this.labels = [];
      this.total = 0;

      for (let key in this.data) {
        let val = this.data[key];
        this.total += val;
      }

      let otherTotal = 0;
      for (let key in this.data) {
        let val = this.data[key];
        let perc = this.percentFromTotal(val, this.total);

        // If perc rounds to 0, add to 'other' label
        if (perc < 0.5) {
          otherTotal += val;
        } else {
          this.fillerdata.push(val);
          this.labels.push(key);
        }
      }

      if (otherTotal > 0) {
        this.fillerdata.push(otherTotal);
        this.labels.push('other');
      }

      this.datacollection = {
        labels: this.labels,
        datasets: [{
          data: this.fillerdata,
          backgroundColor: this.colors,
          borderWidth: 0
        }]
      }
    }
  }
}
